<template>
  <div class="lab-details">
    <div v-if="getSingleLab">
      <div class="each">
        <div class="each-name">
          <img
            src="@/assets/images/icons/confirmation-tests.svg"
            alt="lab"
            width="16"
          />
          <h4 class="ml-10">
            {{ getSingleLab.name }} -
            <span class="">{{ getSingleLab.lab_code }}</span>
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      labDataLoading: false,
    };
  },
  computed: {
    ...mapGetters("labs", ["getSingleLab"]),
  },
  async mounted() {
    await this.fetchLabDetailsById();
  },
  methods: {
    async fetchLabDetailsById() {
      this.labDataLoading = true;
      try {
        await this.$store.dispatch(
          "labs/fetchSingleLab",
          this.$route.params.lab_id
        );
        this.labDataLoading = false;
      } catch (err) {
        this.labDataLoading = false;
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lab-details {
  border-radius: 0px;
  transition: 0.3s ease-in-out all;
  .heading {
    font-size: 1.1em;
    margin-bottom: 10px !important;
    display: block;
    color: #7348bf;
  }
  .each {
    margin-bottom: 5px;
    h4 {
      vertical-align: middle;
      padding-top: 3px;
      font-weight: 600;
      text-transform: uppercase;
      color: #363636;
      .code {
        color: #7348bf;
        background-color: #ffffff;
        padding: 1px 4px;
        border-radius: 4px;
        margin-left: 5px;
        letter-spacing: 1px;
      }
    }
    label {
      color: #34495e;
      opacity: 0.8;
      letter-spacing: 0.5px;
      margin-bottom: 3px !important;
      font-size: 0.91em !important;
    }
    p {
      margin: 0;
    }
    .each-name {
      display: flex;
      align-items: center;
      white-space: nowrap;
    }
  }
}
</style>
